(() => {
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));

  const formatMoney = (cents) =>
    '$' + (Number(cents || 0) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const sizedImage = (url, w) => {
    if (!url) return '';
    if (url.indexOf('?') > -1) return url + '&width=' + w;
    return url + '?width=' + w;
  };

  const init = () => {
    const drawer = document.querySelector('[data-cd-drawer]');
    if (!drawer || drawer.dataset.cdInit === 'true') return;
    drawer.dataset.cdInit = 'true';

    const overlay = document.querySelector('[data-cd-overlay]');
    const closeBtn = drawer.querySelector('[data-cd-close]');
    const shipEl = drawer.querySelector('[data-cd-ship]');
    const itemsEl = drawer.querySelector('[data-cd-items]');
    const emptyEl = drawer.querySelector('[data-cd-empty]');
    const footerEl = drawer.querySelector('[data-cd-footer]');
    const subtotalEl = drawer.querySelector('[data-cd-subtotal]');
    const countEl = drawer.querySelector('[data-cd-count]');
    const threshold = Number(drawer.dataset.freeShippingThreshold || 0);

    let restoreOverflow = null;
    const lockScroll = () => {
      if (restoreOverflow) return;
      const prev = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      restoreOverflow = () => {
        document.documentElement.style.overflow = prev;
        restoreOverflow = null;
      };
    };
    const unlockScroll = () => { if (restoreOverflow) restoreOverflow(); };

    /* -------------------- cart drawer -------------------- */
    const openDrawer = () => {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll();
      drawer.focus({ preventScroll: true });
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      unlockScroll();
    };
    const drawerOpen = () => drawer.classList.contains('is-open');

    const updateCartBadge = (count) => {
      document.querySelectorAll('[data-main-nav-cart]').forEach((el) => {
        if (count > 0) el.setAttribute('data-cart-count', count);
        else el.removeAttribute('data-cart-count');
      });
      if (countEl) countEl.textContent = '— ' + (count || 0);
    };

    const itemHTML = (item) => `
      <div class="cd-item" data-cd-item data-key="${esc(item.key)}">
        <a href="${esc(item.url)}" class="cd-item__media">
          ${item.image ? `<img src="${esc(sizedImage(item.image, 160))}" alt="${esc(item.product_title)}">` : ''}
        </a>
        <div class="cd-item__body">
          <div class="cd-item__row">
            <a href="${esc(item.url)}" class="cd-item__title">${esc(item.product_title || item.title)}</a>
            <button type="button" class="cd-item__remove" data-cd-remove aria-label="Remove">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg>
            </button>
          </div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cd-item__variant">${esc(item.variant_title)}</p>` : ''}
          <div class="cd-item__foot">
            <div class="cd-qty">
              <button type="button" data-cd-dec aria-label="Decrease quantity">−</button>
              <span class="cd-qty__num">${item.quantity}</span>
              <button type="button" data-cd-inc aria-label="Increase quantity">+</button>
            </div>
            <span class="cd-item__price">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
      </div>`;

    const renderShipping = (cart) => {
      if (!shipEl) return;
      if (threshold <= 0) { shipEl.hidden = true; return; }
      const total = cart.total_price;
      const remaining = Math.max(0, threshold - total);
      const pct = Math.min(100, (total / threshold) * 100);
      shipEl.hidden = false;
      shipEl.innerHTML = `
        <p class="cd-ship__text">${remaining > 0 ? `Add ${formatMoney(remaining)} more for free shipping.` : 'Your order qualifies for free shipping.'}</p>
        <div class="cd-ship__track"><div class="cd-ship__fill" style="width:${pct}%"></div></div>`;
    };

    const renderCart = (cart) => {
      updateCartBadge(cart.item_count);
      renderShipping(cart);
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.hidden = true;
        if (shipEl) shipEl.hidden = true;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.hidden = false;
      itemsEl.innerHTML = cart.items.map(itemHTML).join('');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    };

    const fetchCart = async () => {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    };

    const changeLine = async (key, quantity) => {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      renderCart(cart);
    };

    const refreshAndOpen = async () => {
      const cart = await fetchCart();
      renderCart(cart);
      openDrawer();
    };

    // line item quantity + remove
    itemsEl.addEventListener('click', (e) => {
      const line = e.target.closest('[data-cd-item]');
      if (!line) return;
      const key = line.dataset.key;
      const qtyNum = Number(line.querySelector('.cd-qty__num')?.textContent || 0);
      if (e.target.closest('[data-cd-remove]')) { changeLine(key, 0); return; }
      if (e.target.closest('[data-cd-inc]')) { changeLine(key, qtyNum + 1); return; }
      if (e.target.closest('[data-cd-dec]')) { changeLine(key, Math.max(0, qtyNum - 1)); return; }
    });

    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('[data-cd-close-link]').forEach((el) => el.addEventListener('click', closeDrawer));

    // intercept the header cart icon -> open drawer instead of navigating
    document.addEventListener('click', (e) => {
      const cartBtn = e.target.closest('[data-main-nav-cart]');
      if (!cartBtn) return;
      e.preventDefault();
      refreshAndOpen();
    });

    /* -------------------- quick-buy modal -------------------- */
    const qb = document.querySelector('[data-qb-modal]');
    const qbOverlay = document.querySelector('[data-qb-overlay]');
    if (qb) {
      const qbImage = qb.querySelector('[data-qb-image]');
      const qbTitle = qb.querySelector('[data-qb-title]');
      const qbPrice = qb.querySelector('[data-qb-price]');
      const qbOptions = qb.querySelector('[data-qb-options]');
      const qbAdd = qb.querySelector('[data-qb-add]');
      const qbStatus = qb.querySelector('[data-qb-status]');
      const qbClose = qb.querySelector('[data-qb-close]');
      const qbViewLink = qb.querySelector('[data-qb-viewlink]');

      let qbData = null;
      let selected = [];

      const openQb = () => {
        qb.classList.add('is-open');
        if (qbOverlay) qbOverlay.classList.add('is-open');
        qb.setAttribute('aria-hidden', 'false');
        lockScroll();
        qb.focus({ preventScroll: true });
      };
      const closeQb = () => {
        qb.classList.remove('is-open');
        if (qbOverlay) qbOverlay.classList.remove('is-open');
        qb.setAttribute('aria-hidden', 'true');
        if (!drawerOpen()) unlockScroll();
      };

      const resolveVariant = () =>
        qbData.variants.find((v) => v.options.every((o, i) => o === selected[i])) || null;

      const valueAvailable = (index, value) => {
        const candidate = selected.slice();
        candidate[index] = value;
        return qbData.variants.some(
          (v) => v.available && candidate.every((val, i) => val == null || v.options[i] === val)
        );
      };

      const renderState = () => {
        // availability + checked state on each pill
        qbOptions.querySelectorAll('[data-qb-val]').forEach((btn) => {
          const idx = Number(btn.dataset.index);
          const val = btn.dataset.value;
          btn.setAttribute('aria-checked', selected[idx] === val ? 'true' : 'false');
          btn.disabled = !valueAvailable(idx, val);
        });
        const variant = resolveVariant();
        if (variant && variant.image) qbImage.src = sizedImage(variant.image, 700);
        if (variant) {
          qbAdd.disabled = !variant.available;
          qbAdd.textContent = variant.available ? 'Add to bag' : 'Sold out';
          qbPrice.textContent = formatMoney(variant.price);
        } else {
          qbAdd.disabled = true;
          qbAdd.textContent = 'Choose options';
        }
      };

      const buildOptions = () => {
        const names = qbData.optionNames || [];
        qbOptions.innerHTML = names
          .map((name, idx) => {
            const seen = [];
            qbData.variants.forEach((v) => {
              const val = v.options[idx];
              if (!seen.includes(val)) seen.push(val);
            });
            return `
              <div class="qb-opt">
                <div class="qb-opt__label">${esc(name)}</div>
                <div class="qb-opt__values">
                  ${seen
                    .map((val) => `<button type="button" class="qb-val" data-qb-val data-index="${idx}" data-value="${esc(val)}" role="checkbox" aria-checked="false">${esc(val)}</button>`)
                    .join('')}
                </div>
              </div>`;
          })
          .join('');
      };

      const initSelection = () => {
        const firstAvail = qbData.variants.find((v) => v.available) || qbData.variants[0];
        selected = firstAvail ? firstAvail.options.slice() : [];
      };

      const openQuickBuy = (data) => {
        qbData = data;
        qbTitle.textContent = data.title || '';
        if (qbViewLink) qbViewLink.href = data.url || '#';
        qbStatus.textContent = '';
        qbImage.src = sizedImage(data.image, 700);
        qbImage.alt = data.title || '';
        buildOptions();
        initSelection();
        renderState();
        openQb();
      };

      qbOptions.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-qb-val]');
        if (!btn || btn.disabled) return;
        selected[Number(btn.dataset.index)] = btn.dataset.value;
        renderState();
      });

      qbAdd.addEventListener('click', async () => {
        const variant = resolveVariant();
        if (!variant || !variant.available) return;
        qbAdd.disabled = true;
        qbAdd.textContent = 'Adding…';
        qbStatus.textContent = '';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 }),
          });
          if (!res.ok) throw new Error('add failed');
          closeQb();
          await refreshAndOpen();
        } catch (err) {
          qbAdd.disabled = false;
          qbAdd.textContent = 'Add to bag';
          qbStatus.textContent = 'Sorry, could not add. Please try again.';
        }
      });

      qbClose?.addEventListener('click', closeQb);
      qbOverlay?.addEventListener('click', closeQb);

      // open quick-buy from any product card plus button.
      // Use pointerup so a single tap works on touch devices (avoids the
      // iOS hover-emulation double-tap), then swallow the ghost click.
      const handleQuickAddOpen = (e) => {
        const plus = e.target.closest('[data-quick-add]');
        if (!plus) return;
        e.preventDefault();
        const card = plus.closest('.group') || plus.parentElement;
        const dataEl = card ? card.querySelector('[data-quick-add-data]') : null;
        if (!dataEl) return;
        let data;
        try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
        openQuickBuy(data);
      };

      document.addEventListener('pointerup', handleQuickAddOpen);
      // Fallback for browsers without pointer events + block the ghost click.
      document.addEventListener('click', (e) => {
        const plus = e.target.closest('[data-quick-add]');
        if (!plus) return;
        e.preventDefault();
        if (!window.PointerEvent) handleQuickAddOpen(e);
      });

      // shared escape handler
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (qb.classList.contains('is-open')) { closeQb(); return; }
        if (drawerOpen()) closeDrawer();
      });
    } else {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawerOpen()) closeDrawer();
      });
    }

    // Prime the badge on load from the current cart.
    fetchCart().then((cart) => updateCartBadge(cart.item_count)).catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();